import React, { useMemo } from 'react';
import { useSvgStore } from '../../store/svgStore';
import SvgPreview from '../common/SvgPreview';
import { SvgNodeElement } from '../../types/svgTypes';

// 定义模拟数据接口
interface MockAsset {
  id: string;
  name: string;
  svg_code: string;
  is_public: boolean;
  from_ai_prompt?: string;
}

// 模拟数据集
// 修复：添加显式的 width 和 height 属性，防止 SVG 默认撑满全屏导致"太大"或无法预览
const MOCK_ASSETS: MockAsset[] = [
  {
    id: 'mock_user_icon',
    name: '用户头像',
    is_public: true,
    svg_code: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="8" r="4" fill="#818cf8" fill-opacity="0.2" stroke="#6366f1" stroke-width="2"/><path d="M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="#6366f1" stroke-width="2" stroke-linecap="round"/></svg>`,
  },
  {
    id: 'mock_chart_pie',
    name: '分析饼图',
    is_public: true,
    svg_code: `<svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 12L20 12A8 8 0 0 0 12 4V12Z" fill="#818cf8"/><path d="M12 12V4A8 8 0 0 0 4 12H12Z" fill="#c7d2fe"/><path d="M12 12H4A8 8 0 0 0 12 20V12Z" fill="#4f46e5"/><path d="M12 12V20A8 8 0 0 0 20 12H12Z" fill="#a5b4fc"/></svg>`,
  },
  {
    id: 'mock_status_warning',
    name: '警告状态',
    is_public: true,
    svg_code: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4L4 20H20L12 4Z" stroke="#fbbf24" stroke-width="2" stroke-linejoin="round" fill="#fffbeb"/><path d="M12 10V14" stroke="#fbbf24" stroke-width="2" stroke-linecap="round"/><path d="M12 17V17.01" stroke="#fbbf24" stroke-width="2" stroke-linecap="round"/></svg>`,
  },
  {
    id: 'mock_btn_primary',
    name: '主按钮',
    is_public: true,
    svg_code: `<svg width="120" height="48" viewBox="0 0 100 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="40" rx="20" fill="#4f46e5"/><text x="50" y="25" fill="white" font-family="sans-serif" font-size="14" text-anchor="middle">Click Me</text></svg>`,
  }
];

const SvgAssetLibrary: React.FC = () => {
  const assets = useSvgStore((state) => state.assets);
  // 新增：获取 canvas 信息以便计算中心位置
  const canvas = useSvgStore((state) => state.canvas);
  const addElement = useSvgStore((state) => state.addElement);

  // 如果 Store 中没有数据，则使用模拟数据进行展示
  const displayAssets = useMemo(() => {
    if (assets && assets.length > 0) {
      return assets;
    }
    return MOCK_ASSETS;
  }, [assets]);

  const handleAddAssetToCanvas = (assetId: string, svgCode: string) => {
    // 修复：计算画布中心点（假设画布默认 1200x800，如果 canvas 未加载则给个默认值）
    // 减去 50 (大约 asset 的一半大小) 来尝试居中
    const centerX = canvas ? (canvas.width / 2) - 30 : 400;
    const centerY = canvas ? (canvas.height / 2) - 30 : 300;

    const element: SvgNodeElement = {
      id: `asset_${assetId}_${Date.now()}`,
      type: 'svg',
      sourceType: 'asset',
      assetId,
      svgContent: svgCode,
      x: centerX, 
      y: centerY,
      scale: 1,
      rotation: 0,
      opacity: 1,
      name: 'Asset Node',
    };
    addElement(element);
  };

  return (
    <div className="ai-svg-asset-library-light">
      <div className="ai-svg-asset-grid-light">
        {displayAssets.map((asset) => (
          <button
            key={asset.id}
            type="button"
            className="ai-svg-asset-card-light"
            onClick={() => handleAddAssetToCanvas(asset.id, asset.svg_code)}
            title={`点击添加到画布: ${asset.name}`}
          >
            <div className="ai-svg-asset-preview-light">
              <SvgPreview svgContent={asset.svg_code} />
            </div>
            <div className="ai-svg-asset-name-light">{asset.name}</div>
          </button>
        ))}
        {displayAssets.length === 0 && (
          <div className="ai-svg-empty-state-light">
            暂无素材，可以从 AI 生成结果中保存
          </div>
        )}
      </div>
    </div>
  );
};

export default SvgAssetLibrary;